import React, { useState } from "react";
import axios from "axios";
import { Send } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ContactForm = () => {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sending, setSending] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success("Message sent! Our team will get back to you shortly.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      toast.error("Could not send your message. Please try again.");
    } finally {
      setSending(false);
    }
  };

  const inputCls =
    "w-full bg-transparent border border-[#F4EFE8]/25 rounded-sm px-4 py-3 text-[14px] text-[#F4EFE8] placeholder-[#F4EFE8]/40 outline-none focus:border-[#F4EFE8] transition-colors";

  return (
    <form onSubmit={submit} className="space-y-3">
      <div className="grid sm:grid-cols-2 gap-3">
        <input className={inputCls} placeholder="Your name" required value={form.name} onChange={set("name")} />
        <input className={inputCls} type="email" placeholder="Email address" required value={form.email} onChange={set("email")} />
      </div>
      <input className={inputCls} placeholder="Subject (optional)" value={form.subject} onChange={set("subject")} />
      <textarea
        className={`${inputCls} resize-none`}
        rows={3}
        placeholder="How can we help?"
        required
        value={form.message}
        onChange={set("message")}
      />
      <button
        type="submit"
        disabled={sending}
        className="btn-lux-light px-7 py-3 text-[12px] tracking-[0.2em] uppercase gap-2 disabled:opacity-60"
      >
        {sending ? "Sending..." : <>Send Message <Send size={14} /></>}
      </button>
    </form>
  );
};

export default ContactForm;
